module.exports = __webpack_public_path__ + "img/seccion1.1.9ef71b6a.png";